// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"b20e8344","302":"4357f24e","369":"64959b62","389":"572a031d"}[chunkId] + ".chunk.js";
};